(function(){
  function detectActiveLang(){
    // 1) spróbuj odczytać język z document.documentElement.lang
    var htmlLang = document.documentElement.lang;
    if(htmlLang){
      return htmlLang.toLowerCase().startsWith('pl') ? 'PL' : 'EN';
    }
    // 2) spróbuj od Shopify.locale (jeśli dostępne)
    if(window.Shopify && window.Shopify.locale){
      return window.Shopify.locale.toLowerCase().startsWith('pl') ? 'PL' : 'EN';
    }
    // 3) spróbuj odczytać pierwszą część ścieżki URL (np. /pl/ lub /en/)
    var m = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
    if(m){
      return m[1].toLowerCase() === 'pl' ? 'PL' : 'EN';
    }
    // fallback
    return 'EN';
  }

  function filterSizePopup(popupRoot){
    try{
      var active = detectActiveLang();
      var guides = popupRoot.querySelectorAll('.esc-size-guide');
      guides.forEach(function(g){
        var titleEl = g.querySelector('.esc-size-guide--title');
        var title = (titleEl && titleEl.innerText) ? titleEl.innerText.trim() : '';
        var isPL = /(\bPL\b|Polish|Polski)/i.test(title);
        var isEN = /(\bEN\b|English|Angielski)/i.test(title);
        if(active === 'PL'){
          if(isPL) g.style.display = '';
          else g.style.display = 'none';
        } else {
          if(isEN) g.style.display = '';
          else g.style.display = 'none';
        }
      });
    }catch(e){
      console.error('filterSizePopup error', e);
    }
  }

  // Jeśli popup już w DOM, przefiltruj go natychmiast
  document.querySelectorAll('.esc-size-guide--popup').forEach(function(p){
    filterSizePopup(p);
  });

  // Obserwuj DOM — aplikacja może wstrzykiwać popup dynamicznie
  var obs = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if(!(node instanceof HTMLElement)) return;
        if(node.matches && node.matches('.esc-size-guide--popup')){
          filterSizePopup(node);
        } else if(node.querySelector){
          var popupInside = node.querySelector('.esc-size-guide--popup');
          if(popupInside) filterSizePopup(popupInside);
        }
      });
    });
  });
  obs.observe(document.documentElement || document.body, { childList: true, subtree: true });

})();
